import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Paper, Typography, Button, Chip } from '@mui/material';
import { DataGrid, type GridColDef } from '@mui/x-data-grid';
import AddIcon from '@mui/icons-material/Add';
import { format } from 'date-fns';
import { es } from 'date-fns/locale';
import { useCobranzaStore } from '../store/cobranzaStore';

export const CobranzaPage: React.FC = () => {
  const navigate = useNavigate();
  const { cobranzas, loading, fetchCobranzas } = useCobranzaStore();

  useEffect(() => { fetchCobranzas(); }, [fetchCobranzas]);

  const columns: GridColDef[] = [
    { field: 'numero', headerName: 'Numero', width: 120 },
    { field: 'fechaCobranza', headerName: 'Fecha', width: 120, valueFormatter: (value: string) => { try { return format(new Date(value), 'dd/MM/yyyy', { locale: es }); } catch { return value; } } },
    { field: 'persona', headerName: 'Cliente', flex: 1, minWidth: 200, valueGetter: (value: any) => value?.personaContacto || '-' },
    { field: 'formaPago', headerName: 'Forma Pago', width: 130, valueGetter: (value: any) => value?.descripcion || '-' },
    { field: 'montoTotal', headerName: 'Monto', width: 120, type: 'number', valueFormatter: (value: number) => `S/ ${(value ?? 0).toFixed(2)}` },
    { field: 'estado', headerName: 'Estado', width: 100, renderCell: (params) => <Chip label={params.value || '-'} color={params.value === 'APL' ? 'success' : params.value === 'ANU' ? 'error' : 'default'} size="small" /> },
  ];

  return (
    <Box sx={{ p: 3 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Typography variant="h5" fontWeight="bold">Cobranza</Typography>
        <Button variant="contained" startIcon={<AddIcon />} onClick={() => navigate('/ventas/cobranza/nueva')}>Nuevo Cobro</Button>
      </Box>
      <Paper sx={{ height: 600 }}>
        <DataGrid rows={cobranzas} columns={columns} getRowId={(row) => row.idCobranza} loading={loading}
          pageSizeOptions={[10, 20, 50]} initialState={{ pagination: { paginationModel: { pageSize: 20 } } }}
          onRowClick={(params) => navigate(`/ventas/cobranza/${params.row.idCobranza}`)}
          sx={{ cursor: 'pointer', border: 'none' }} disableRowSelectionOnClick />
      </Paper>
    </Box>
  );
};
